import { OWManager } from "../../OW.Remoting/Remoting/OWManager";
import { ISignatureReferenceUriGenerator } from "./ISignatureReferenceUriGenerator";

export class RemotingObjectReferenceUriGenerator implements ISignatureReferenceUriGenerator {
    private readonly _serializationFormat: string;
    private readonly _schemaIdentifier: string;

    constructor(serializationFormat: string, schemaIdentifier: string) {
        this._serializationFormat = serializationFormat;
        this._schemaIdentifier = schemaIdentifier;
    }

    public async getReferenceUri(): Promise<string> {
        const serverId = await OWManager.getServerId();

        return `tescosw://${serverId}/dataService/sameObject?format=${this._serializationFormat}&serializationSchemaVersion=${this._schemaIdentifier}`; //`
    }
}
